import React, { useEffect } from "react";
import "./TestimonialSection.scss";
const TestimonialSection = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (window.Trustpilot) {
        window.Trustpilot.loadFromElement(
          document.querySelector(".trustpilot-widget")
        );
      }
    };

    return () => {
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return (
    <div className="testimonialSectionContainer">
      <div className="testimonialSectionWrapper">
        <div className="testimonialHeader">
          <p>Testimonials</p>
          <h2>Trust Us - You’re In Safe Hands</h2>
        </div>
        <div
          class="trustpilot-widget"
          data-locale="en-GB"
          data-template-id="539adbd6dec7e10e686debee"
          data-businessunit-id="62053dd91174fa6f10b67256"
          data-style-height="500px"
          data-style-width="100%"
          data-stars="4,5"
          data-review-languages="en"
          data-theme="light"
        >
          <a
            href="https://uk.trustpilot.com/review/alphacapitalgroup.uk"
            target="_blank"
            rel="noopener"
          >
            Trustpilot
          </a>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSection;
